import { WRONG_CREDENTIALS_ERROR } from "./error-codes.constants";
import ApiError from "../../../errors/ApiError";

export default class WrongCredentialsError extends ApiError {
  constructor() {
    super(WRONG_CREDENTIALS_ERROR);
  }
}
